// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".auto-expand-enter[data-v-bd75ee0e],.auto-expand-enter-active[data-v-bd75ee0e],.auto-expand-leave[data-v-bd75ee0e],.auto-expand-leave-active[data-v-bd75ee0e]{transition:all .25s cubic-bezier(0.4, 0, 1, 1) !important;overflow:hidden}@media(prefers-reduced-motion: reduce){.auto-expand-enter[data-v-bd75ee0e],.auto-expand-enter-active[data-v-bd75ee0e],.auto-expand-leave[data-v-bd75ee0e],.auto-expand-leave-active[data-v-bd75ee0e]{transition:unset !important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
